import { Box, SxProps, Theme } from "@mui/material";

interface ShutterProps {
  active: boolean; // whether animation is running
  flaps?: number;
  sx?: SxProps<Theme>;
  flash?: boolean; // optional flash effect
}

const ShutterCapture: React.FC<ShutterProps> = ({ active, flaps = 6, sx, flash = true }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
        transition: 'background-color 0.2s ease',
        ...sx,
      }}
    >
      {Array.from({ length: flaps }, (_, i) => (
        <Box
          key={`flap-${i}`}
          sx={{
            '--i': i,
            width: '150vmax',
            height: '150vmax',
            position: 'absolute',
            bottom: '50%',
            right: '50%',
            transformOrigin: 'bottom right',
            background: 'linear-gradient(35deg, #222, #000)',
            border: '1px solid #999',
            transform: `rotate(-0.5turn) rotate(calc(1turn * var(--i) / ${flaps})) skewX(30deg) translateX(-100%) translateY(90%)`,
            animation: active ? `shutter 0.5s ease-in-out forwards` : 'none',
          }}
        />
      ))}

       {active && flash && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'white',
            opacity: 0,
            animation: 'flash 0.15s ease-in-out',
            pointerEvents: 'none',
          }}
        />
      )}

      <style>
        {`
          @keyframes shutter {
            0%, 40% {
              transform: rotate(-0.5turn) rotate(calc(1turn * var(--i) / ${flaps})) skewX(30deg) translateX(-100%) translateY(90%);
            }
            50%, 60% {
              transform: rotate(-0.25turn) rotate(calc(1turn * var(--i) / ${flaps})) skewX(30deg) translateX(0%) translateY(0%);
            }
            100% {
              transform: rotate(-0.5turn) rotate(calc(1turn * var(--i) / ${flaps})) skewX(30deg) translateX(-100%) translateY(90%);
            }
          }

           @keyframes flash {
            0% { opacity: 0; }
            50% { opacity: 0.8; }
            100% { opacity: 0; }
          }

        `}
      </style>
    </Box>
  );
};

export default ShutterCapture;